// 三高收款地区编码独立于华大基因的地区名称；旧无地区链接默认广州。
export const collectionAreas = [
  { code: 1, name: "上海" },
  { code: 2, name: "广州" },
  { code: 3, name: "天津" },
];

export function resolveSanGaoAreaCode(value) {
  if (value == null || value === "") return 2;
  const area = collectionAreas.find(item => value === item.code || value === String(item.code));
  return area ? area.code : null;
}

// productId 对应 product_mark=43 的权益项 privilege_type，价格由后台返回。
// 类型 2 是历史合并项目，类型 3 仍为糖尿病，新增 4/5 分别为高血压/高尿酸。
export const repairProjects = [
  {
    id: 1,
    name: "心脑防猝",
    description: "心脑健康风险管理",
  },
  {
    id: 4,
    name: "三高治疗-高血压",
    description: "高血压专项",
  },
  {
    id: 5,
    name: "三高治疗-高尿酸",
    description: "高尿酸专项",
  },
  {
    id: 3,
    name: "三高治疗-2型糖尿病",
    description: "2型糖尿病专项",
  },
];

// productId 对应 product_mark=44 的权益项 privilege_type。
export const giftProjects = [
  {
    id: 1,
    name: "心脑直通车",
    price: 100,
    description: "三高修复到会礼",
  },
  {
    id: 2,
    name: "NTproBNP",
    price: 150,
    description: "三高修复到会礼",
  },
];

export function createCustomer() {
  return {
    personName: "",
    personIdCard: "",
    personPhone: "",
    checkStartTime: "",
    productList: [],
    sum: 0,
  };
}
